import { useContext } from "react";
import Panel from "../Panel";
import classnames from "classnames";
import { Message } from "semantic-ui-react";
import { themeContext } from "../../containers/ThemeProvider";

export const ON_NET_TEXT = "On-net";
export const OFF_NET_TEXT = "Off-net";

export default function ZenBroadbandGroup({
  broadbandGroup,
  selectedProduct,
  selectProduct,
  lineDetails,
}) {
  const { products, broadbandType, onNet, provider } = broadbandGroup;
  const networkType = onNet ? ON_NET_TEXT : OFF_NET_TEXT;
  const { assets } = useContext(themeContext);

  let message = "";

  switch (broadbandType.toUpperCase()) {
    case "FTTC":
      message = lineDetails?.fttc?.availabilityDescription || lineDetails?.fttc?.ragDescription;
      break;
    case "SOGEA":
      message = lineDetails?.sogea?.availabilityDescription || lineDetails?.sogea?.ragDescription;
      break;
    case "COPPER":
      message =
        lineDetails?.adsl2Plus?.availabilityDescription ||
        lineDetails?.adsl2Plus?.ragDescription ||
        lineDetails?.adsl2PlusAnnexM?.availabilityDescription ||
        lineDetails?.adsl2PlusAnnexM?.ragDescription;
      break;
    case "GFAST":
      message = lineDetails?.gFast?.availabilityDescription || lineDetails?.gFast?.ragDescription;
      break;
    case "FTTP":
      message = lineDetails?.fttp?.availabilityDescription || lineDetails?.fttp?.ragDescription;
      break;
    case "FTTP SYMMETRICAL":
      message = lineDetails?.FttpSymmetrical?.availabilityDescription || lineDetails?.FttpSymmetrical?.ragDescription;
      break;
    default:
      message = "";
  }

  return (
    <>
      {message && <Message info header={message} />}
      <Panel header={broadbandType} className="zen-broadband-group">
        <div
          className="products-container"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "12px",
          }}
        >
          {products.map((product) => (
            <div
              key={product.productCode}
              onClick={() => selectProduct(product)}
              className={classnames("product", {
                selected: selectedProduct === product,
              })}
              style={{
                border: "1px solid #ccc",
                borderRadius: "6px",
                padding: "10px 12px",
                width: "calc(33.33% - 12px)",
                minHeight: "120px",
                boxSizing: "border-box",
                cursor: "pointer",
              }}
            >
              <p
                className="product__title"
                style={{
                  fontSize: "1.05em",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  color: assets?.headerColour,
                  marginBottom: "8px",
                  lineHeight: "1.3",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                }}
              >
                {product.productName}
              </p>

              <div
                className="product__info"
                style={{
                  fontSize: "0.8em",
                  fontWeight: "bold",
                  lineHeight: "1.4",
                }}
              >
                {product?.marketLocation?.toLowerCase() !== "unavailable" && (
                  <p>Market Location: {product.marketLocation}</p>
                )}
                <p>
                  {networkType} {broadbandType} is available
                </p>
                <p>Provider: {provider}</p>
              </div>
            </div>
          ))}
        </div>
      </Panel>
    </>
  );
}
